// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { intlFormatDistance as fn } from "../intlFormatDistance.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const intlFormatDistanceWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default intlFormatDistanceWithOptions;
